<template>
    <div class="text-center">
        <v-dialog
            v-model="openSessionTimeoutWarning"
            width="500"
            persistent
        >
            <v-card>
                <v-card-title class="title text-h5 grey lighten-2">
                  {{ $t('sessionTimeoutWarning.title') }}
                </v-card-title>
                <v-card-text
                :style="{padding: '2.2rem !important'}">
                  {{ $t('sessionTimeoutWarning.message') }}
                  <CountdownTimer
                    v-if="openSessionTimeoutWarning"
                    :endDate="new Date().setMinutes(new Date().getMinutes() + 1)"
                    @sessionEnded="isEnded = $event"
                  >
                  </CountdownTimer>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="!isEnded"
                    color="primary"
                    text
                    @click="reloadTimeout"
                    >
                    {{ $t('sessionTimeoutWarning.buttons.continue') }}
                    </v-btn>
                    <v-btn v-else
                    color="primary"
                    text
                    @click="logout"
                    >
                    {{ $t('sessionTimeoutWarning.buttons.logout') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import CountdownTimer from './CountdownTimer.vue';

export default {
  props: {
    openSessionTimeoutWarning: Boolean,
  },
  components: {
    CountdownTimer,
  },
  data() {
    return {
      isEnded: false,
    };
  },
  methods: {
    logout() {
      const movil = this.$store.getters['globalState/get']('deviceOS');

      this.$emit('closeSessionTimeoutWarning', false);
      this.$emit('sessionLogout');
      localStorage.setItem('sessionExpired', 'true');
      if (movil) {
        this.$router.push({ name: 'Login' });
      } else {
        this.$router.push({ name: 'AnnouncementApp' });
      }
    },
    closeDialog() {
      this.$emit('closeSessionTimeoutWarning', false);
    },
    reloadTimeout() {
      this.$api.getClient('registerSession').lastAccess();
      this.closeDialog();
    },
  },
  watch: {
    isEnded: function (val) { // eslint-disable-line
      if (val) {
        this.logout();
      }
    },
  },
};
</script>

<style scoped>
    .title {
        box-shadow: 0 2px 4px -1px rgba(0,0,0,.2),
                    0 4px 5px 0 rgba(0,0,0,.14),
                    0 1px 10px 0 rgba(0,0,0,.12) !important;
    }
</style>
